export const underwritingProvisionsInitialState = [
    {
        id: 1,
        title: "No-Evidence Limit per Life (NEL)",
        amount: 0,
        ageRange: "",
    },
    {
        id: 2,
        title: "Non-Medical Limit per Life (NMed)",
        amount: 0,
        ageRange: "",
    },
    {
        id: 3,
        title: "Medical Limit per Life (Med)",
        description: "",
    },
    {
        id: 4,
        title: "Maximum Amount of Insurance per Life",
        amount: 0,
        ageRange: "",
    },
]

export const participationRequirementsInitialState = [
    {
        id: 1,
        title: "Percentage of all Eligible Individuals",
        amount: "",
    },
    {
        id: 2,
        title: "Minimum Number of Insureds",
        amount: "",
    },
]